module.exports = __webpack_public_path__ + "img/frame5.566ba5f2.png";